import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ForbiddenPageComponent } from './components/forbidden-page/forbidden-page.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';

import { TeacherGuard } from './guard/teacher.guard';
import { ApplicationsService } from './services/applications.service';
import { ContentsService } from './services/contents.service';

import { ErrorService } from './services/error.service';
import { HttpServiceInterceptor } from './services/http-service-interceptor';
import { MeService } from './services/me.service';
import { MenuService } from './services/menu.service';
import { UsingApplicationsService } from './services/using-applications.service';

const COMPONENTS = [ErrorPageComponent, NotFoundPageComponent, ForbiddenPageComponent];

@NgModule({
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
  imports: [SharedModule],
  providers: [
    ApplicationsService,
    ErrorService,
    MeService,
    MenuService,
    UsingApplicationsService,
    ContentsService,
    TeacherGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpServiceInterceptor,
      multi: true,
    },
    provideHttpClient(
      withInterceptorsFromDi(),
      withXsrfConfiguration({
        cookieName: 'CSRF-TOKEN',
        headerName: 'X-CSRF-Token',
      }),
    ),
  ],
})
export class CoreModule {
  /**
   * CoreModule はルートのモジュールで一度だけ読み込まれるようにする
   * @see {@link https://angular.io/guide/ngmodule#prevent-reimport-of-the-coremodule}
   */
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
